export default "__VITE_ASSET__CBpwT2Hz__"